export enum MenuPosition {
  LEFT = 'left',
  RIGHT = 'right'
}
